import { Component, OnInit, Output, EventEmitter, HostBinding, Renderer2, Inject } from '@angular/core';
import { DataService } from '../../_services/data.service';
import { Router, ActivatedRoute, NavigationEnd, NavigationStart } from '@angular/router';
import { AuthService } from '../../_services/auth.service';
import { slideUp, slideUpMenu, anim } from 'src/app/animations';
import { DOCUMENT } from '@angular/common';
import { overduePaymentAlert } from 'src/app/_core/_function/overduePaymentAlert';
import { postMessageToIframe } from 'src/app/_core/_function/postMessageToIframe';
// import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-test-menu',
  templateUrl: './test-menu.component.html',
  styleUrls: ['./test-menu.component.scss'],
  host: { '[class.active]': 'showMenu' },
  animations: [
    slideUp, slideUpMenu, anim
  ]
})

export class TestMenuComponent implements OnInit {
  showMenu: boolean = true;
  removeAllMenu: boolean = false;
  showBuildingSubMenu: boolean = false;
  projUid: string;
  compId: any;
  user: any;
  proj: any;
  projId: string;
  routeParams: {};
  currentSituation: boolean = false;
  showSubGallery: boolean = false;
  iframeElement;
  itemsCounter: number;
  date:any;

  @Output()
  public projPassToParent = new EventEmitter();

  @Output()
  public projPassToParentShowMenu = new EventEmitter();
  modulesArray: any[] = [];
  mySubscription: any;
  url: any;
  showFloorsViewSubMenu = false;
  galleryIdInput: any;
  params: any;
  removeListOfProjects: boolean;
  showMenuDGalTrigger: any = true;
  galleryType: any;
  allgalleries: boolean = true;
  projectlist: boolean = false;
  showAdminButton: boolean = true;
  companyTitle: string;
  projectTitle: string;
  compositeDesign: boolean = false;
  unika: boolean = false;
  desktopResolution: boolean = true;
  @HostBinding('class.hide-menu') hideMenu: boolean = false;
  urlSwitcher: string = '';
  sehelProjId: string = '';
  // location: string = '';
  weatherWidget: any = {};
  timeOut:boolean = false;
  curProj: any;
  projectlistToTheWorld:any;
  projectlistToIncognito:boolean = false;
  showProjTitle: boolean = false;
  showCompLogo: boolean = false;
  projects: any;
  toggleProjList: boolean = false;
  toggleProjListMenu: boolean = false;
  hoisUrl: string = "";
  
  @HostBinding('class.reduce-menu') reduceMenu: boolean = false;
  supportPayment: boolean = false;
  classAlert: string = "";
  currentLanguage: string = 'he';
  multilang: boolean = false;
  @HostBinding('class') get class() {
    return this.projectTitle + ' ' + this.companyTitle;
  }

  constructor(
    public dataService: DataService,
    private route: ActivatedRoute,
    private router: Router,
    public auth: AuthService,
    private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document
  ) {
    this.compId = this.route.firstChild.snapshot.params.id;
    this.projUid = this.route.firstChild.snapshot.params.idp;
  }

  ngOnInit(): void {
    // <script async src="https://static1.sharpweather.com/widgetjs/?id=id8afb94496aa8e"></script>
    // <script async src="https://static1.sharpweather.com/widgetjs/?id=idfd8dd07ce4ebf"></script>
    this.hoisUrl = this.dataService.hoisUrl();
    this.date = new Date();
    console.log(this.date)
    this.urlSwitcher = this.dataService.wichDesign().urlSwitcher;
    this.compositeDesign = this.dataService.wichDesign().compositeDesign;
    this.unika = this.dataService.wichDesign().unika;
    this.unika = this.dataService.wichDesign().unika;
    // setTimeout(() => {
    //   let companyAndProject = localStorage.getItem('companyAndProject');
    //   const objcompanyAndProject = JSON.parse(companyAndProject);
    //   this.companyTitle = objcompanyAndProject.companyName;
    //   this.projectTitle = objcompanyAndProject.projectName;
    // }, 1000);
    if (!this.unika) {
      this.route.queryParamMap.subscribe(params => {
        this.params = params;
        if (this.params.params.m !== undefined) {
          this.removeListOfProjects = true;
          if (this.params.params.m === 'all') {
            this.projPassToParentShowMenu.emit('true');
            this.removeAllMenu = true;
            this.hideMenu = true;
            this.showMenu = false;
            this.removeListOfProjects = true;
            localStorage.setItem('removeAllMenu', JSON.stringify(true));
          } else {
            localStorage.setItem('removeAllMenu', JSON.stringify(false));
          }
        } else {
          localStorage.setItem('removeAllMenu', JSON.stringify(false));
        }
      });
    }

    // localStorage.setItem('companyAndProject', JSON.stringify(''));
    //A--------------A
    this.route.firstChild.url.subscribe(segment => {
      segment.values;
      if (segment.length > 3) {
        for (let i = 0; segment.length > i; i++) {
          if (segment[i].path === 'n') {
            this.compositeDesign = true;
          } else if (segment[i].path === 'u') {
            this.compositeDesign = true;
            this.unika = true;
          }
        }
      }
    })
    if (window.innerWidth < 1200) {
      this.desktopResolution = false; 
    }
    // if (window.location.origin === 'https://spirical.net' || 'bs-localStorage.com:4200' || 'http://localhost:4200/') {
      if (window.location.origin === 'https://spirical.net') { 
      this.showAdminButton = false;
      this.reduceMenu = true;
    }

    this.sehelProjId = this.route.firstChild.snapshot.params.sehelProjId;
      // this.compId = this.route.firstChild.snapshot.params.id;
      // this.projUid = this.route.firstChild.snapshot.params.idp;
      console.log(this.projId);
      if (window.innerWidth < 1200) {
        this.showMenu = false; 
      }
      
      this.dataService.getItemsByCompId(this.compId).subscribe(projects => { 
        // if (projects.length <= 1) {
        //   this.projectlist = false;
        // } else  {
        //   this.projectlist = true;
        // }
        this.projects = projects;
        let curProj = projects.filter(proj => proj.uid === this.projUid);
        if(curProj[0]){
          if(curProj[0].weatherWidget !== '' && curProj[0].weatherWidget && curProj[0].weatherWidget.id) {
            // this.weatherWidget.locs = 
            this.weatherWidget = curProj[0].weatherWidget;
            console.log(this.weatherWidget.id)
            let script = this._renderer2.createElement('script');
            script.src = 'https://static1.sharpweather.com/widgetjs/?id='+this.weatherWidget.id;
            
            script.async = true;
            // this._renderer2.appendChild(this._document.body, script);
    
            // setTimeout(() => {
              this._renderer2.appendChild(this._document.body, script);
            // }, 100)
            // setTimeout(() => {
            //   this.timeOut = true;
            // }, 100)
          }
          if(curProj[0].toggleProjListMenu) {
            this.toggleProjListMenu = curProj[0].toggleProjListMenu;
          }
          if (curProj[0].projectlist) {
            this.projectlist = curProj[0].projectlist;
          } 
        }
        if (curProj.length > 0) {
          this.companyTitle = curProj[0].companyTitle;
          if (this.route.snapshot.queryParams.lang === 'en') {
            this.projectTitle = curProj[0].titleEn;
          } else {
            this.projectTitle = curProj[0].title;
          }
          if(curProj[0].titleEn && curProj[0].title) {
            this.multilang = true;

          }
          if(curProj[0].showProjTitle !== undefined) {
            this.showProjTitle = curProj[0].showProjTitle;
          } else {
            this.showProjTitle = true;
          }
          if(curProj[0].showCompLogo !== undefined) {
            this.showCompLogo = curProj[0].showCompLogo;
          } else {
            this.showCompLogo = true;
          }
          
          this.curProj = curProj[0];
          if(curProj[0].projectlistToTheWorld) {
            this.projectlistToTheWorld = curProj[0].projectlistToTheWorld;
          } else {
            this.projectlistToTheWorld = 'false';
          }
          if(curProj[0].projectlistToIncognito  ) {
            this.projectlistToIncognito = curProj[0].projectlistToIncognito;
          } else {
            this.projectlistToIncognito  = false;
          }
              
        }
      });

    this.dataService.removeMenu.subscribe(removeOrNot => {
      this.removeAllMenu = removeOrNot;
      this.reloadMenu();
    })
    this.galleryIdInput = this.route.firstChild.snapshot.params.galleryId;
    let ifChanged;
    this.url = window.location.toString();
    this.routeParams = this.route.snapshot.firstChild.params;
    let id = this.route.snapshot.paramMap.get('id');
    let idp: string;
    this.user = this.auth.currentUserValue;

    if (this.route.firstChild.snapshot.params.galleryId) {
      this.galleryIdInput = this.route.firstChild.snapshot.params.galleryId;
    }

    // if (this.url.indexOf('constructionPoint') < 0) {
    this.router.events.subscribe((val) => {
      // this.url = window.location.toString();
      if (this.url !== ifChanged) {
        ifChanged = window.location.toString();
        // if (this.url.indexOf('test') > 0 && this.url.indexOf('building') < 0) {
        if (this.route.snapshot.firstChild.params.idp && this.url.indexOf('building') < 0) {
          if (window.innerWidth > 1200) {
            this.showMenu = true;
          }
          this.projUid = this.route.snapshot.firstChild.params.idp;
          this.routeParams = this.route.snapshot.firstChild.params;
          this.dataService.getSpecProject(this.projUid).subscribe(proj => {
            this.proj = proj[0];
            this.projId = this.proj.id;
            this.companyTitle = this.proj.companyTitle;
            // this.projectTitle = this.proj.title;
            if (this.route.snapshot.queryParams.lang === 'en') {
              this.projectTitle = this.proj.titleEn;
            } else {
              this.projectTitle = this.proj.title;
            }
            if (this.proj.projectList) {
              this.projectlist = this.proj.projectList;
            } 
            const companyAndProject = { 'companyName': this.companyTitle, 'projectName': this.projectTitle }
            localStorage.setItem('companyAndProject', JSON.stringify(companyAndProject));
            this.projPassToParent.emit(proj);
            this.dataService.currentProject(this.proj);
            // this.modulesArray = proj[0].modules;
            this.switchModules(proj[0]);
          });
          this.reloadMenu();
        } else if (this.url.indexOf('building') > 0) {
          if (window.innerWidth > 1200) {
            this.showMenu = true;
          }
        } else {
          this.showMenu = false;
        }
      }
    });
    this.ifShowMenu();
    // }
    if (id === 'Null' || id === null) {
      id = this.route.firstChild.snapshot.params.id;
    }
    if (this.route.firstChild) {
      if (!this.route.firstChild.snapshot.params.idp) {
        this.showMenu = false;
        this.projPassToParentShowMenu.emit(this.showMenu);
      } else {
        if (window.innerWidth > 1200) {
          this.showMenu = true;
          this.projPassToParentShowMenu.emit(this.showMenu);
        }

        idp = this.route.firstChild.snapshot.params.idp;
        this.routeParams = this.route.firstChild.snapshot.params;
      }
    } else {
      idp = this.route.snapshot.params.idp;
      this.routeParams = this.route.snapshot.params;

    }
    if (idp) {
      this.projUid = idp;
      this.dataService.getSpecProject(this.projUid).subscribe(proj => {
        this.proj = proj[0];

        let overduePayment = overduePaymentAlert(proj[0]);
        if(overduePayment) {
          this.classAlert = overduePayment.classAlert;
          this.supportPayment = overduePayment.supportPayment;
        }

        this.projId = this.proj.id;
        this.modulesArray = proj[0].modules;
        this.companyTitle = this.proj.companyTitle;
        // this.projectTitle = this.proj.title;
        if (this.route.snapshot.queryParams.lang === 'en') {
          this.projectTitle = this.proj.titleEn;
        } else {
          this.projectTitle = this.proj.title;
        }
        this.projPassToParent.emit(proj);
        // this.modulesArray = proj[0].modules;
        let pathArray = window.location.pathname.split('?');
        this.switchModules(proj[0]);
        this.showMenu = true;
        if (this.proj.projectList) {
          this.projectlist = this.proj.projectList;
        } 
      });
      this.ifShowMenu();
      // this.showMenu = true;
      this.projPassToParentShowMenu.emit(true);
      this.mySubscription = this.router.events.subscribe((event) => {
        if (onanimationend) {
          if (event instanceof onanimationend) {
            // Trick the Router into believing it's last link wasn't previously loaded
            this.router.navigated = false;
          }
        }

      });
      // this.projUid = this.route.snapshot.params.idp;
      // this.compId = id;
      this.dataService.getSpecProject(this.projUid).subscribe(proj => {
        this.proj = proj[0];
        this.projId = this.proj.id;
        if (this.proj.companyTitle) {
          this.companyTitle = this.proj.companyTitle;
        } else {
          this.companyTitle = '';
        }
        // this.projectTitle = this.proj.title;
        if (this.route.snapshot.queryParams.lang === 'en') {
          this.projectTitle = this.proj.titleEn;
        } else {
          this.projectTitle = this.proj.title;
        }
        if (this.proj.projectList === false) {
          this.projectlist = false;
        }
        const companyAndProject = { "companyName": this.companyTitle, "projectName": this.projectTitle }
        localStorage.setItem('companyAndProject', JSON.stringify(companyAndProject));
        this.projPassToParent.emit(proj);
        this.modulesArray = proj[0].modules;
        this.switchModules(proj[0]);
      });
    } else {
      this.removeAllMenu = true;
    }

    // hide modules on start
    this.route.queryParamMap.subscribe(params => {
      this.params = params;
      if (this.params.params.m !== undefined) {
        this.removeListOfProjects = true;
        if (this.params.params.m === 'all') {
          this.projPassToParentShowMenu.emit('true');
          this.removeAllMenu = true;
          this.hideMenu = true;
          this.showMenu = false;
          this.removeListOfProjects = true;
          localStorage.setItem('removeAllMenu', JSON.stringify(true));
        } else {
          localStorage.setItem('removeAllMenu', JSON.stringify(false));
        }
      } else {
        localStorage.setItem('removeAllMenu', JSON.stringify(false));
      }
    });
  }

  changeLanguage(lang) {
   // Get the current query parameters
   const queryParams = { ...this.route.snapshot.queryParams };
    
   // Toggle the `lang` parameter
   if (queryParams['lang'] === 'en' && lang == 'he') {
     queryParams['lang'] = 'he';
   } else if (queryParams['lang'] === 'he' && lang == 'en') {
    queryParams['lang'] = 'en';
  } else {
    return;
  }

   // Navigate with updated query parameters
   this.router.navigate([], {
    relativeTo: this.route,
    queryParams: queryParams,
    queryParamsHandling: 'merge'
  }).then(() => {
    // Trigger a full navigation cycle
    window.location.href = this.router.url;
  });
  }
  toggleProjListF(){
    this.toggleProjList = !this.toggleProjList;
  }

  goToAdmin() {

    // window.open(this.proj.link, '_blank');
    this.router.navigate(['admin/company/' + this.route.firstChild.snapshot.params.id]);
    // this.router.navigate([this.urlSwitcher + this.route.firstChild.snapshot.params.id + '/' + this.projUid]);
  }
  reloadMenu() {
    this.route.firstChild.url.subscribe(segment => {
      segment.values;
      if (segment.length > 2) {
        for (let i = 0; segment.length > i; i++) {
          if (segment[i].path === 'n') {
            this.compositeDesign = true;
          } else if (segment[i].path === 'u') {
            this.compositeDesign = true;
            this.unika = true;
          }
        }
      }
    })
    this.removeAllMenu = false;
    this.galleryIdInput = this.route.firstChild.snapshot.params.galleryId;
    let ifChanged;
    this.url = window.location.toString();
    this.routeParams = this.route.snapshot.firstChild.params;
    let id = this.route.snapshot.paramMap.get('id');
    let idp: string;
    this.user = this.auth.currentUserValue;

    if (this.route.firstChild.snapshot.params.galleryId) {
      this.galleryIdInput = this.route.firstChild.snapshot.params.galleryId;
    }

    if (this.url.indexOf('constructionPoint') < 0) {
      this.router.events.subscribe((val) => {
        this.url = window.location.toString();
        if (this.url !== ifChanged) {
          ifChanged = window.location.toString();
          // if (this.url.indexOf('test') > 0 && this.url.indexOf('building') < 0) {
          if (this.route.snapshot.firstChild.params.idp && this.url.indexOf('building') < 0) {
            if (window.innerWidth > 1200) {
              this.showMenu = true;
            }
            this.projUid = this.route.snapshot.firstChild.params.idp;
            this.routeParams = this.route.snapshot.firstChild.params;
            this.dataService.getSpecProject(this.projUid).subscribe(proj => {
              this.proj = proj[0];
              this.projId = this.proj.id;
              this.companyTitle = this.proj.companyTitle;
              // this.projectTitle = this.proj.title;
              if (this.route.snapshot.queryParams.lang === 'en') {
                this.projectTitle = this.proj.titleEn;
              } else {
                this.projectTitle = this.proj.title;
              }
              this.projPassToParent.emit(proj);
              // this.modulesArray = proj[0].modules;
              this.switchModules(proj[0]);
            });
          } else if (this.url.indexOf('building') > 0) {
            if (window.innerWidth > 1200) {
              this.showMenu = true;
            }
          } else {
            this.showMenu = false;
          }
          this.projPassToParentShowMenu.emit(this.showMenu);
        }
      });
      this.ifShowMenu();
    }
    if (id === 'Null') {
      id = this.route.firstChild.snapshot.params.id;
    }
    if (this.route.firstChild) {
      if (!this.route.firstChild.snapshot.params.idp) {
        this.showMenu = false;
        this.projPassToParentShowMenu.emit(this.showMenu);
      } else {
        if (window.innerWidth > 1200) {
          this.showMenu = true;
          this.projPassToParentShowMenu.emit(this.showMenu);
        }

        idp = this.route.firstChild.snapshot.params.idp;
        this.routeParams = this.route.firstChild.snapshot.params;
      }
    } else {
      idp = this.route.snapshot.params.idp;
      this.routeParams = this.route.snapshot.params;
    }
    if (idp) {
      this.projUid = idp;
      this.ifShowMenu();
      // this.showMenu = true;
      this.projPassToParentShowMenu.emit(this.showMenu);
      this.mySubscription = this.router.events.subscribe((event) => {
        if (onanimationend) {
          if (event instanceof onanimationend) {
            // Trick the Router into believing it's last link wasn't previously loaded
            this.router.navigated = false;
          }
        }

      });
      // this.projUid = this.route.snapshot.params.idp;
      // this.compId = id;
      this.dataService.getSpecProject(this.projUid).subscribe(proj => {
        this.proj = proj[0];
        this.projId = this.proj.id;
        this.companyTitle = this.proj.companyTitle;
        // this.projectTitle = this.proj.title;
        if (this.route.snapshot.queryParams.lang === 'en') {
          this.projectTitle = this.proj.titleEn;
        } else {
          this.projectTitle = this.proj.title;
        }
        this.projPassToParent.emit(proj);
        this.modulesArray = proj[0].modules;
        this.switchModules(proj[0]);
      });
    } else {
      this.removeAllMenu = true;
    }

    // hide modules on start
    this.route.queryParamMap.subscribe(params => {
      this.params = params;
      if (this.params.params.m !== undefined) {
        this.removeListOfProjects = true;
        if (this.params.params.m === 'all') {
          this.projPassToParentShowMenu.emit('true');
          this.removeAllMenu = true;
          this.hideMenu = true;
          this.showMenu = false;
          this.removeListOfProjects = true;
          localStorage.setItem('removeAllMenu', JSON.stringify(true));
        } else {
          localStorage.setItem('removeAllMenu', JSON.stringify(false));
        }
      } else {
        localStorage.setItem('removeAllMenu', JSON.stringify(false));
      }
    });
    return;
  }
  itemsCounterF(itemsCounter) {
    this.itemsCounter = itemsCounter;
  }
  currentModulesOnStart() {
    if (this.modulesArray[0]) {
      if (this.params.params.m.length > 0) {
        let array = this.params.params.m.split(',');
        for (let i = 0; array.length > i; i++) {
          switch (array[i]) {
            case 'currentsituation':
              this.modulesArray[0]['currentSituationTitle'] = false;
              break;
            case 'video':
              this.modulesArray[0]['videoTitle'] = false;
              break;
            case 'pdf':
              this.modulesArray[0]['pdfTitle'] = false;
              break;
            case 'area':
              this.modulesArray[0]['areaTitle'] = false;
              break;
            case 'floors':
              this.modulesArray[0]['floorsTitle'] = false;
              break;
            case 'simulators':
              this.modulesArray[0]['simulatorsTitle'] = false;
              break;
            case 'buildings':
              this.modulesArray[0]['buildingsTitle'] = false;
              break;
            case 'constructionpoint':
              this.modulesArray[0]['constructionPointTitle'] = false;
              break;
            case 'linkToSite':
              this.modulesArray[0]['linkToSiteTitle'] = false;
              break;
            case 'simple':
              this.modulesArray[0]['simpleTitle'] = false;
              break;
            case 'simple1':
              this.modulesArray[0]['simple1Title'] = false;
              break;
            case 'simple2':
              this.modulesArray[0]['simple2Title'] = false;
              break;
            case 'simple3':
              this.modulesArray[0]['simple3Title'] = false;
              break;
            case 'allgalleries':
              this.allgalleries = false;
              break;
            case 'projectlist':
              this.projectlist = false;
              break;
          }
        }
        this.removeListOfProjects = true;
        // this.router.navigate(['/company/' + this.route.snapshot.paramMap.get("id") + '/test/' + this.proj.uid], { queryParams: { m: this.params.params.m } });
      }
    }
  }
  closeSubMenu(event) {
    this.galleryType = "";
    this.showSubGallery = event;
    if (!this.desktopResolution) {
      this.showMenu = event;
    }
  }

  switchModules(items) {
    if (items.modules) {
      for (let i = 0; items.modules.length > i; i++) {
        const moduleNameTrigger = items.modules[i];
        // this.modulesArray[0][moduleNameTrigger.moduleName] = true;
        if (this.modulesArray[0]) {
          switch (moduleNameTrigger.moduleName) {
            case 'currentSituation':
              this.modulesArray[0]['currentSituationTitle'] = moduleNameTrigger.currentSituationTitle;
              break;
            case 'video':
              this.modulesArray[0]['videoTitle'] = moduleNameTrigger.videoTitle;
              break;
            case 'pdf':
              this.modulesArray[0]['pdfTitle'] = moduleNameTrigger.pdfTitle;
              break;
            case 'area':
              this.modulesArray[0]['areaTitle'] = moduleNameTrigger.areaTitle;
              break;
            case 'floors':
              this.modulesArray[0]['floorsTitle'] = moduleNameTrigger.floorsTitle;
              break;
            case 'simulators':
              this.modulesArray[0]['simulatorsTitle'] = moduleNameTrigger.simulatorsTitle;
              break;
            case 'buildings':
              this.modulesArray[0]['buildingsTitle'] = moduleNameTrigger.buildingsTitle;
              break;
            case 'constructionPoint':
              this.modulesArray[0]['constructionPointTitle'] = moduleNameTrigger.constructionPointTitle;
              break;
            case 'linkToSite':
              this.modulesArray[0]['linkToSiteTitle'] = moduleNameTrigger.linkToSiteTitle;
              break;
            case 'simple':
              this.modulesArray[0]['simpleTitle'] = moduleNameTrigger.simpleTitle;
              break;
            case 'simple1':
              this.modulesArray[0]['simple1Title'] = moduleNameTrigger.simple1Title;
              break;
            case 'simple2':
              this.modulesArray[0]['simple2Title'] = moduleNameTrigger.simple2Title;
              break;
            case 'simple3':
              this.modulesArray[0]['simple3Title'] = moduleNameTrigger.simple3Title;
              break;
            default:
          }
        }
        let test = window.location.pathname.split('?')
        if (this.params) {
          if (this.params.params.m) {
            this.currentModulesOnStart();
          }
        }
      }
    }
  };

  openCurrentSituation($event, currentSituationId) {
    // this.router.navigate(['/company/' + this.route.firstChild.snapshot.params.id + '/' + this.projUid + '/test']);
    this.currentSituation = !this.currentSituation;
    let data = {
      scene: currentSituationId, // pano ID
      autorotate: false,
    };
    // Set url to be sure that the message will be sent to only this url
    // Full url to iframe
    if (this.currentSituation) {
      data = {
        scene: currentSituationId, // pano ID
        autorotate: false,
      };
    } else {
      data = {
        scene: this.proj.panoramaView, // pano ID
        autorotate: false,
      };
    }
    const url = 'https://topeye.club/';
    //  Access iframe by name
    // const win = window.frames.tourIframe;
    // this.router.navigate(['/company/' + this.route.firstChild.snapshot.params.id + '/' + this.projUid + '/test']);
    this.router.navigate(['/company/' + this.route.firstChild.snapshot.params.id + '/' + this.projUid]);

    postMessageToIframe(data);
    // const test = document.getElementsByClassName('da-iframe');
    // const test1 = test[0].getElementsByTagName('iframe')[0];
    // const win = test1;
    // this.iframeElement = eval('(win.contentWindow || win.contentDocument)');
    // this.iframeElement.postMessage(JSON.stringify(data), url);
    // this.ifShowMenu();
  }

  goToProject() {
    // this.router.navigate(['/company/' + this.route.firstChild.snapshot.params.id + '/' + this.projUid + '/test']);

    this.router.navigate([this.urlSwitcher + this.route.firstChild.snapshot.params.id + '/' + this.projUid]);
    // if (this.compositeDesign && !this.unika) {
    //   this.router.navigate(['/company/n/' + this.route.firstChild.snapshot.params.id + '/' + this.projUid]);
    // } else if (this.unika) {
    //   this.router.navigate(['/company/u/' + this.route.firstChild.snapshot.params.id + '/' + this.projUid]);
    // }
    //  else {
    //   this.router.navigate(['/company/' + this.route.firstChild.snapshot.params.id + '/' + this.projUid]);
    // }
    this.goToHomePano();
    this.ifShowMenu();
  }
  goToHomePano() {
    // this.closeViewFloors();
    const data = {
      scene: this.proj.panoramaView, // pano ID
      autorotate: false,
    };
    // Set url to be sure that the message will be sent to only this url
    // Full url to iframe

    postMessageToIframe(data);

    // const url = 'https://topeye.club/';
    //  Access iframe by name
    // const win = window.frames.tourIframe;
    // const test = document.getElementsByClassName("da-iframe");
    // let test1: HTMLIFrameElement;
    // if (test.length > 0) {
    //   const test1 = test[0].getElementsByTagName('iframe')[0];
    // }
    // const win = test1;

    // if (win) {
    //   this.iframeElement = eval("(win.contentWindow || win.contentDocument)");
    //   this.iframeElement.postMessage(JSON.stringify(data), url);
    // }
  }
  openConstructionTrucing() {
    // this.router.navigate(['/company/' + this.route.firstChild.snapshot.params.id + '/' + this.projUid + '/test/constructionPoint/']);

    this.router.navigate([this.urlSwitcher + this.route.firstChild.snapshot.params.id + '/' + this.projUid + '/constructionPoint/']);
    // if (this.compositeDesign && !this.unika) {
    //   this.router.navigate(['/company/n/' + this.route.firstChild.snapshot.params.id + '/' + this.projUid + '/constructionPoint/']);
    //   //   this.router.routeReuseStrategy.shouldReuseRoute = function () {
    //   //     return false;
    //   // };
    // } else if (this.unika) {
    //   this.router.navigate(['/company/u/' + this.route.firstChild.snapshot.params.id + '/' + this.projUid + '/constructionPoint/']);
    // } else {
    //   this.router.navigate(['/company/' + this.route.firstChild.snapshot.params.id + '/' + this.projUid + '/constructionPoint/']);
    // }
    this.ifShowMenu();
  }
  openViewitemArea() {
    // this.router.navigate(['/company/' + this.route.firstChild.snapshot.params.id + '/' + this.projUid + '/test/area/']);
    this.urlSwitcher
    this.router.navigate([this.urlSwitcher + this.route.firstChild.snapshot.params.id + '/' + this.projUid + '/area/']);
    // if (this.compositeDesign && !this.unika) {
    //   this.router.navigate(['/company/n/' + this.route.firstChild.snapshot.params.id + '/' + this.projUid + '/area/']);
    //   //   this.router.routeReuseStrategy.shouldReuseRoute = function () {
    //   //     return false;
    //   // };
    // } else if (this.unika) {
    //   this.router.navigate(['/company/u/' + this.route.firstChild.snapshot.params.id + '/' + this.projUid + '/area/']);
    // } else {
    //   this.router.navigate(['/company/' + this.route.firstChild.snapshot.params.id + '/' + this.projUid + '/area/']);
    // }
    this.ifShowMenu();
  }
  openSimple(type) {
    let galleryType = type;
    this.galleryType = type;
    this.showSubGallery = false;

    this.router.navigate([this.urlSwitcher + this.route.firstChild.snapshot.params.id + '/' + this.projUid + '/gallery/' + this.projId + galleryType]);

    // this.router.navigate(['/company/' + this.route.firstChild.snapshot.params.id + '/' + this.projUid + '/test/gallery/' + this.projId + galleryType]);
    // if (this.compositeDesign && !this.unika) {
    //   this.router.navigate(['/company/n/' + this.route.firstChild.snapshot.params.id + '/' + this.projUid + '/gallery/' + this.projId + galleryType]);
    //   //   this.router.routeReuseStrategy.shouldReuseRoute = function () {
    //   //     return false;
    //   // };
    // }  else if (this.unika) {
    //   this.router.navigate(['/company/u/' + this.route.firstChild.snapshot.params.id + '/' + this.projUid + '/gallery/' + this.projId + galleryType]);
    // } else {
    //   this.router.navigate(['/company/' + this.route.firstChild.snapshot.params.id + '/' + this.projUid + '/gallery/' + this.projId + galleryType]);
    // }
    this.ifShowMenu();
  }
  showMenuPageWithLink() {
    // this.router.navigate(['/company/' + this.route.firstChild.snapshot.params.id + '/' + this.projUid + '/test/galleryD/' + this.projUid]);

    this.router.navigate([this.urlSwitcher + this.route.firstChild.snapshot.params.id + '/' + this.projUid + '/galleryD/' + this.projUid]);

    // if (this.compositeDesign && !this.unika) {
    //   this.router.navigate(['/company/n/' + this.route.firstChild.snapshot.params.id + '/' + this.projUid + '/galleryD/' + this.projUid]);
    //   //   this.router.routeReuseStrategy.shouldReuseRoute = function () {
    //   //     return false;
    //   // };
    // }  else if (this.unika) {
    //   this.router.navigate(['/company/u/' + this.route.firstChild.snapshot.params.id + '/' + this.projUid + '/galleryD/' + this.projUid]);
    // }  else {
    //   this.router.navigate(['/company/' + this.route.firstChild.snapshot.params.id + '/' + this.projUid + '/galleryD/' + this.projUid]);
    // }
    this.ifShowMenu();
  }
  showSubGalleryF($event) {
    this.showSubGallery = !this.showSubGallery;
    this.showBuildingSubMenu = false;
    this.showFloorsViewSubMenu = false;
  }
  showMenuF() {
    this.showMenu = !this.showMenu;
    // this.projPassToParentShowMenu.emit(this.showMenu);
  }
  goToOwnerSite($event) {
    // this.router.navigate([this.proj.link]);
    window.open(this.proj.link, '_blank');
    // this.proj.link
    // this.child.goToUrl($event, this.child.itemToview.link);
    // this.currentItemMenu($event);
    // this.ifShowMenu();
    this.ifShowMenu();
  }
  openBuildings(whichMenu) {
    // if (this.screenResolutionDetecting() < 1200) {
    //   if (this.showFloorsViewSubMenu === true || this.showBuildingSubMenu === true) {
    //     this.showFloorsViewSubMenu = false;
    //     this.screenResolutionDetecting = false;
    //     this.showBuildingSubMenu = false;
    //     this.showMenu = false;
    //   }
    // }
    if (whichMenu === 'buildMenu') {
      this.showBuildingSubMenu = !this.showBuildingSubMenu;
      this.showFloorsViewSubMenu = false;
      this.showSubGallery = false;
    } else if (whichMenu === 'floorMenu') {
      this.showBuildingSubMenu = false;
      this.showFloorsViewSubMenu = !this.showFloorsViewSubMenu;
      this.showSubGallery = false;
    } else if (whichMenu === 'buildMenuSub' || whichMenu === 'floorMenuSub') {
      this.showFloorsViewSubMenu = false;
      this.showSubGallery = false;
      this.showBuildingSubMenu = false;
      if (this.screenResolutionDetecting() < 1200) {
        // this.showMenuF()
        this.ifShowMenu();
        // this.showMenu = false;
      }
    }
  }

  screenResolutionDetecting() {
    return window.innerWidth;
  }
  ifShowMenu() {
    if (this.screenResolutionDetecting() < 1200) {
      this.showMenu = !this.showMenu;
      if (!this.showMenu) {
        if (document.getElementsByClassName("menu").length > 0) {
          document.getElementsByClassName("menu")[0].classList.remove('active');
          document.getElementsByClassName("menu")[0].parentElement.classList.remove('active');
        }
      }
    }
  }
  navigatToMainPage() {
    this.dataService.saveRemoveMenu('false');
    this.showSubGallery = false;
    this.showBuildingSubMenu = false;
    this.showFloorsViewSubMenu = false;
    if(this.curProj.projectlistPano){
      this.router.navigate([this.urlSwitcher + this.route.firstChild.snapshot.params.id]);
    } else {
      this.router.navigate([this.urlSwitcher + this.route.firstChild.snapshot.params.id + '/map']);
    }
    this.projPassToParentShowMenu.emit('false');
    // if (this.compositeDesign && !this.unika) {
    //   this.router.navigate(['/company/n/' + this.route.firstChild.snapshot.params.id]);
    //   //   this.router.routeReuseStrategy.shouldReuseRoute = function () {
    //   //     return false;
    //   // };
    // }  else if (this.unika) {
    //   this.router.navigate(['/company/u/' + this.route.firstChild.snapshot.params.id]);
    // }   else {
    //   this.router.navigate(['/company/' + this.route.firstChild.snapshot.params.id]);
    // }
  }
  showMenuDGalTriggerF(event) {
    this.showMenuDGalTrigger = event;
  }
}
